<template>
  <div id="acChargeDetail">
    <!-- 设备基本信息 -->
    <el-row>
      <div class="headTitle">
        <span style="font-size: 20px;margin-right: 20px;">{{ basicinfo.deviceName }}</span>
        <span style="font-size: 18px;margin-right: 20px;">({{ basicinfo.deviceSn }})</span>
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ basicinfo.deviceTypeT }}</span><!--设备类型-->
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t("yhubReport.FirmwareVersion") }}: V{{ basicinfo.fwVersion }}</span><!--固件-->
      </div>
    </el-row>
    <el-row class="content">
      <!-- 时间 -->
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <!-- <p class="blockTitleP" style="padding-top: 0;padding-left: 0;">
          <i class="el-icon-time" style="font-size: 24px;" />
          <span style="vertical-align: text-bottom;"> {{ timeAgo }}</span>
        </p> -->
        <p class="contentTitle">
          <i class="el-icon-time" style="font-size: 24px;vertical-align: top; margin-top: -5px;" />
          <span style="vertical-align: text-bottom;"> {{ timeAgo }}</span>
        </p>
        <acChargeSetTem :machine-model="acChargeData.machineModel" style="padding-bottom:20px;" />
      </el-col>
      <!-- <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
        <span style="margin-left: 10%;">AC IN</span>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col" style="text-align: right;">
        <span style="margin-right: 10%;">DC SYSTEM</span>
      </el-col> -->
    </el-row>
    <el-row class="middleContentWarp">
      <!-- ac充电器 -->
      <!-- <div class="middleContentWarp"> -->
      <el-col :xs="10" :sm="10" :lg="10" class="card-panel-col middleContentLeft">
        <!-- 插头 -->
        <div class="plugWarp">
          <p style="margin-bottom: 10px;">SHORE POWER</p>
          <div>
            <img v-if="isAllOn" src="@/assets/images/plug_online.png" alt="">
            <img v-if="!isAllOn" src="@/assets/images/plug_offline.png" alt="">
          </div>
          <div>
            <img src="@/assets/images/battery/vsBlack.png" alt="">
            <span>{{ acChargeData.plugV }} V</span>
          </div>
        </div>
        <!-- 箭头 -->
        <div class="arrowBox">
          <div class="soildLine" :class="{'dottedLine':!isAllOn}" />
          <div v-if="isAllOn" class="greenDeltaRight" style="margin-top: -12px;margin-left: 87px;" />
        </div>
        <!-- ac充电器 -->
        <div class="acChargeDiv">
          <div>
            <div class="temInfo">
              <img src="@/assets/images/tem_black.png" alt="" style="height: 40px;">
              <span>{{ acChargeData.acChargeTem }}℃</span>
            </div>
            <p v-if="acChargeData.machineModel" style="margin-bottom: 10px;margin-top: -28px;">AC {{ acChargeData.machineModel }}</p>
            <img v-if="isAllOn" src="@/assets/images/acCharge_online.png" alt="" class="acChargeImg">
            <img v-if="!isAllOn" src="@/assets/images/acCharge_offline.png" alt="" class="acChargeImg">
            <img v-if="isShowWarning" src="@/assets/images/warningIcon.png" alt="" class="warningIcon">
            <p v-if="!isAllOn">OFFLINE</p>
            <p v-if="isAllOn">CHARGING</p>
          </div>
          <div class="acChargeInfo">
            <div>CH1</div>
            <div>CH2</div>
            <div>CH3</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="14" :sm="14" :lg="14" class="card-panel-col middleContentRight">
        <div class="arrowOrLine" :class="{'dottedLine':!isAllOn||!isCellTeamOn1}">
          <div v-if="isAllOn&&isCellTeamOn1" class="greenDeltaBottom" />
        </div>
        <div class="arrowOrLine" :class="{'dottedLine':!isAllOn||!isCellTeamOn2}">
          <div v-if="isAllOn&&isCellTeamOn2" class="greenDeltaBottom" />
        </div>
        <div class="arrowOrLine" :class="{'dottedLine':!isAllOn||!isCellTeamOn3}">
          <div v-if="isAllOn&&isCellTeamOn3" class="greenDeltaBottom" />
        </div>
        <div class="cellTeamBox">
          <p style="margin-bottom: 5px;text-align: center;">Bank One</p>
          <p style="margin-bottom: 5px;text-align: center;">HOUSE BANK</p>
          <img v-if="isAllOn" src="@/assets/images/cellTeam_online.png" alt="">
          <img v-if="!isAllOn" src="@/assets/images/cellTeam_offline.png" alt="">
          <div class="cellTeamBoxInfo">
            <img src="@/assets/images/battery/vBlack.png" alt="">
            <span>{{ acChargeData.cellTeamV1 }}V</span>
          </div>
          <div class="cellTeamBoxInfo">
            <img src="@/assets/images/battery/aBlack.png" alt="">
            <span>{{ acChargeData.cellTeamA1 }}A</span>
          </div>
        </div>
        <div class="cellTeamBox">
          <p style="margin-bottom: 5px;text-align: center;">Bank Two</p>
          <p style="margin-bottom: 5px;text-align: center;">STARTER BANK</p>
          <img v-if="isAllOn" src="@/assets/images/cellTeam_online.png" alt="">
          <img v-if="!isAllOn" src="@/assets/images/cellTeam_offline.png" alt="">
          <div class="cellTeamBoxInfo">
            <img src="@/assets/images/battery/vBlack.png" alt="">
            <span>{{ acChargeData.cellTeamV2 }}V</span>
          </div>
          <div class="cellTeamBoxInfo">
            <img src="@/assets/images/battery/aBlack.png" alt="">
            <span>{{ acChargeData.cellTeamA2 }}A</span>
          </div>
        </div>
        <div class="cellTeamBox">
          <p style="margin-bottom: 5px;text-align: center;">Bank Three</p>
          <p style="margin-bottom: 5px;text-align: center;">AUXILIARY BANK</p>
          <img v-if="isAllOn" src="@/assets/images/cellTeam_online.png" alt="">
          <img v-if="!isAllOn" src="@/assets/images/cellTeam_offline.png" alt="">
          <div class="cellTeamBoxInfo">
            <img src="@/assets/images/battery/vBlack.png" alt="">
            <span>{{ acChargeData.cellTeamV3 }}V</span>
          </div>
          <div class="cellTeamBoxInfo">
            <img src="@/assets/images/battery/aBlack.png" alt="">
            <span>{{ acChargeData.cellTeamA3 }}A</span>
          </div>
        </div>
      </el-col>
      <!-- </div> -->
    </el-row>
  </div>
</template>

<script>

import { findDeviceInfo } from '@/api/bidirectional'
import { howLongAgo } from '@/utils/updateTime.js'
import i18n from '@/i18n'
import acChargeSetTem from './acChargeSetTem'

export default {
  name: 'Bidirectional',
  components: {
    acChargeSetTem
  },
  data() {
    return {
      basicinfo: {},
      isAllOn: false, // 是否在线
      isCellTeamOn1: false, // 电池组1是否在线
      isCellTeamOn2: false, // 电池组2是否在线
      isCellTeamOn3: false, // 电池组3是否在线

      isCharging: false,
      yhubmqtt: {}, // MQTT值
      acChargeMqttData: {}, // 来自MQTT的acCharge的值
      acChargeData: {// ac充电器数据
        plugV: '--',
        acChargeTem: '--',
        cellTeamV1: '--',
        cellTeamA1: '--',
        cellTeamV2: '--',
        cellTeamA2: '--',
        cellTeamV3: '--',
        cellTeamA3: '--',
        machineModel: ''
      },
      isShowWarning: false,
      warningImg: { imgUrl: null }, // 警告--图片

      question: 'When unit is in Battery/Inverter mode, Input battery voltage is too low and AC Output is shutdown.', // 警告--wenti
      answer: 'Recharge the battery immediately and restart unit.', // 警告--答案
      warningInfo: [// 警告文字
        { key: 'A01', question: 'Temperature Sensor (BTS) is defective.', answer: 'Check and or replace the sensor.' },
        { key: 'E01', question: 'Unit shutdown due to low AC Input(< 85 +/- 5Vac)', answer: 'Check AC input source. The unit will automatically recover when the AC Input voltage return to > 108 +/-5Vac' },
        { key: 'E02', question: 'Unit shutdown due to high AC Input(>270 +/- 5Vac)', answer: 'Check AC input source. The unit will automatically recover when the AC Input voltage return to < 260 +/-5Vac' },
        { key: 'E03', question: 'Battery is connected backwards', answer: 'Check all battery connections' },
        { key: 'E04', question: 'Charger Internal temperature is too high and it has to shut down. The unit will automatically recover when the unit cools down.', answer: 'The ventilation of the unit is blocked or the environmental temperature is high. Reduce charging current or improve the ventilation near the unit.' },
        { key: 'E05', question: 'Not used.', answer: '' },
        { key: 'E06', question: 'High battery temperature >70 °C (158°C) is sensed by the BTS. The unit will shut down. The unit will automatically recover when the battery temperature has reduced to 60°C (140°F).', answer: 'Check the battery, charger setting, and its environment.' },
        { key: 'E07', question: 'Low battery temperature < -25°C (-13°F) is sensed by the BTS. The unit will shut down. The unit will automatically recover when battery temperature reaches -20°C (-4°F).', answer: 'It is not recommended to charge the battery at extremely low temperatures.' },
        { key: 'E08', question: 'DC Output fuses are brown.', answer: 'Check battery connection and replace the fuse with the same type and rating.' },
        { key: 'E09', question: 'Unit shutdown due to high battery voltage (> 17 Vdc on 12V model and >34 Vdc on 24V model). The unit will automatically recover when battery Voltage reduced to <16Vdc on 12V model or <32 Vdc on 24V model.', answer: 'Check battery and charger setting. Check also if there is any other DC supply connected to the battery banks.' }
      ],
      timeAgo: '',
      timeAgoRST: '',
      timer: null,
      viewTable: false, // 表格--查看
      editTable: false, // 表格--编辑
      viewBtn: 'open', // 查看/收起配置--按钮
      editBtn: false, // 编辑--按钮
      closeBtn: false, // 取消--按钮
      modelType: null,
      tableEditObj: {
        CH1: true,
        CH2: true,
        CH3: true,
        GAFChargeOrFloatACh1: [],
        GAFChargeOrFloatACh2: [],
        GAFChargeOrFloatACh3: [],
        lithiumChargeOrFloatACh1: [],
        lithiumChargeOrFloatACh2: [],
        lithiumChargeOrFloatACh3: []
      },
      disabledEdit: true
    }
  },
  computed: {
    storeYhubmqtt() {
      return this.$store.state.yhubmqtt// 需要监听的数据
    },
    tableData: function() {
      return this.tableDataAll.filter(function(item) {
        return item.isShow
      })
    }
  },
  watch: {
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        this.MQTT()
      },
      deep: true
    },
    tableEditObjBatteryTypeCh1: {
      handler(newValue, oldValue) {
        console.log(newValue)
        this.tableDataAll.forEach(v => {
          if (newValue == 1 || newValue == 5) { // GEL/AGM
            if (v.sort == 'Ch1') {
              v.isShow = false
              if (v.key == 'GAFChargeOrFloatA' || v.key == 'chargeStage' || v.key == 'tempCompensation') {
                v.isShow = true
              }
            }
          } else if (newValue == 2) { // Flooded
            if (v.sort == 'Ch1') {
              v.isShow = false
              if (v.key == 'GAFChargeOrFloatA' || v.key == 'chargeStage' || v.key == 'eqStatus' || v.key == 'tempCompensation') {
                v.isShow = true
              }
            }
          } else if (newValue == 3) { // Lithium
            if (v.sort == 'Ch1') {
              v.isShow = false
              if (v.key == 'lithiumV' || v.key == 'lithiumChargeOrFloatA') {
                v.isShow = true
              }
            }
          } else if (newValue == 4) { // Program
            if (v.sort == 'Ch1') {
              v.isShow = false
              if (v.key == 'proV' || v.key == 'proA' || v.key == 'chargeStage') {
                v.isShow = true
              }
            }
          }
        })
        console.log(this.GAFAOptions)
        // console.log(this.yhubmqtt.payload)
      },
      deep: true
    },
    tableEditObjBatteryTypeCh2: {
      handler(newValue, oldValue) {
        console.log(newValue)
        this.tableDataAll.forEach(v => {
          // v.isShow = true
          if (newValue == 1 || newValue == 5) { // GEL/AGM
            if (v.sort == 'Ch2') {
              v.isShow = false
              if (v.key == 'GAFChargeOrFloatA' || v.key == 'chargeStage' || v.key == 'tempCompensation') {
                v.isShow = true
              }
            }
          } else if (newValue == 2) { // Flooded
            if (v.sort == 'Ch2') {
              v.isShow = false
              if (v.key == 'GAFChargeOrFloatA' || v.key == 'chargeStage' || v.key == 'eqStatus' || v.key == 'tempCompensation') {
                v.isShow = true
              }
            }
          } else if (newValue == 3) { // Lithium
            if (v.sort == 'Ch2') {
              v.isShow = false
              if (v.key == 'lithiumV' || v.key == 'lithiumChargeOrFloatA') {
                v.isShow = true
              }
            }
          } else if (newValue == 4) { // Program
            if (v.sort == 'Ch2') {
              v.isShow = false
              if (v.key == 'proV' || v.key == 'proA' || v.key == 'chargeStage') {
                v.isShow = true
              }
            }
          }
        })
        // console.log(this.yhubmqtt.payload)
      },
      deep: true
    },
    tableEditObjBatteryTypeCh3: {
      handler(newValue, oldValue) {
        console.log(newValue)
        this.tableDataAll.forEach(v => {
          if (newValue == 1 || newValue == 5) { // GEL/AGM
            if (v.sort == 'Ch3') {
              v.isShow = false
              if (v.key == 'GAFChargeOrFloatA' || v.key == 'chargeStage' || v.key == 'tempCompensation') {
                v.isShow = true
              }
            }
          } else if (newValue == 2) { // Flooded
            if (v.sort == 'Ch3') {
              v.isShow = false
              if (v.key == 'GAFChargeOrFloatA' || v.key == 'chargeStage' || v.key == 'eqStatus' || v.key == 'tempCompensation') {
                v.isShow = true
              }
            }
          } else if (newValue == 3) { // Lithium
            if (v.sort == 'Ch3') {
              v.isShow = false
              if (v.key == 'lithiumV' || v.key == 'lithiumChargeOrFloatA') {
                v.isShow = true
              }
            }
          } else if (newValue == 4) { // Program
            if (v.sort == 'Ch3') {
              v.isShow = false
              if (v.key == 'proV' || v.key == 'proA' || v.key == 'chargeStage') {
                v.isShow = true
              }
            }
          }
        })
        // console.log(this.yhubmqtt.payload)
      },
      deep: true
    },
    modelType: {// 型号
      handler(newValue, oldValue) {
        console.log(newValue)
        if (newValue.indexOf('2012') > -1 || newValue.indexOf('1220') > -1) {
          this.GAFAOptions = [
            {
              value: '3',
              label: 'Bulk 20A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 2A' },
                { value: '3', label: 'Float 4A' }
              ]
            },
            {
              value: '2',
              label: 'Bulk 15A',
              children: [
                { value: '1', label: 'Float 0.75A' },
                { value: '2', label: 'Float 1.5A' },
                { value: '3', label: 'Float 3A' }
              ]
            },
            {
              value: '1',
              label: 'Bulk 10A',
              children: [
                { value: '1', label: 'Float 0.5A' },
                { value: '2', label: 'Float 1A' },
                { value: '3', label: 'Float 2A' }
              ]
            },
            {
              value: '4',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 0.3A' },
                { value: '2', label: 'Float 0.5A' },
                { value: '3', label: 'Float 1A' }
              ]
            }
          ]
        } else if (newValue.indexOf('4012') > -1 || newValue.indexOf('1240') > -1) {
          this.GAFAOptions = [
            {
              value: '3',
              label: 'Bulk 40A',
              children: [
                { value: '1', label: 'Float 2A' },
                { value: '2', label: 'Float 4A' },
                { value: '3', label: 'Float 8A' }
              ]
            },
            {
              value: '2',
              label: 'Bulk 20A',
              children: [
                { value: '1', label: 'Float 0.75A' },
                { value: '2', label: 'Float 1.5A' },
                { value: '3', label: 'Float 3A' }
              ]
            },
            {
              value: '1',
              label: 'Bulk 10A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 2A' },
                { value: '3', label: 'Float 4A' }
              ]
            },
            {
              value: '4',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 0.3A' },
                { value: '2', label: 'Float 0.5A' },
                { value: '3', label: 'Float 1A' }
              ]
            }
          ]
        } else if (newValue.indexOf('6012') > -1 || newValue.indexOf('1260') > -1) {
          this.GAFAOptions = [
            {
              value: '3',
              label: 'Bulk 60A',
              children: [
                { value: '1', label: 'Float 3A' },
                { value: '2', label: 'Float 6A' },
                { value: '3', label: 'Float 12A' }
              ]
            },
            {
              value: '2',
              label: 'Bulk 40A',
              children: [
                { value: '1', label: 'Float 2A' },
                { value: '2', label: 'Float 4A' },
                { value: '3', label: 'Float 8A' }
              ]
            },
            {
              value: '1',
              label: 'Bulk 20A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 2A' },
                { value: '3', label: 'Float 4A' }
              ]
            },
            {
              value: '4',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 0.3A' },
                { value: '2', label: 'Float 0.5A' },
                { value: '3', label: 'Float 1A' }
              ]
            }
          ]
        } else if (newValue.indexOf('3024') > -1 || newValue.indexOf('2430') > -1) {
          this.GAFAOptions = [
            {
              value: '1',
              label: 'Bulk 30A',
              children: [
                { value: '1', label: 'Float 1.5A' },
                { value: '2', label: 'Float 3A' },
                { value: '3', label: 'Float 6A' }
              ]
            },
            {
              value: '2',
              label: 'Bulk 20A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 2A' },
                { value: '3', label: 'Float 4A' }
              ]
            },
            {
              value: '3',
              label: 'Bulk 10A',
              children: [
                { value: '1', label: 'Float 0.5A' },
                { value: '2', label: 'Float 1A' },
                { value: '3', label: 'Float 2A' }
              ]
            },
            {
              value: '4',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 0.3A' },
                { value: '2', label: 'Float 0.5A' },
                { value: '3', label: 'Float 1A' }
              ]
            }
          ]
        }
        console.log(this.GAFAOptions)
      },
      deep: true
    }
  },
  mounted() {
    this.queryList()
  },
  created() {
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  destroyed: function() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  methods: {
    queryList() {
      var param = {
        'mcuId': this.$route.query.mcuId
      }
      // 设备信息
      findDeviceInfo(param).then(res => {
        // 设备信息详情
        this.basicinfo = res.resultModel
        this.basicinfo.deviceTypeT = this.$route.query.deviceTypeT
      })
    },
    submitSet(obj) {
      this.viewTable = this.editBtn = obj.editBtn
      this.editTable = this.closeBtn = obj.closeBtn
      this.viewBtn = obj.viewBtn
    },
    setDisabledEdit(val) {
      this.disabledEdit = val
    },
    clickSet(val) {
      if (val == 'close') { // 收起
        this.viewTable = this.editTable = this.editBtn = false
        this.viewBtn = 'open'
      } else { // 查看
        this.editBtn = this.viewTable = true
        this.viewBtn = 'close'
      }
    },
    edit() {
      this.viewBtn = ''
      this.editTable = this.closeBtn = true
      this.viewTable = this.editBtn = false
    },
    close() {
      this.editTable = this.closeBtn = false
      this.viewBtn = 'close'
      this.viewTable = this.editBtn = true
    },
    change(e) {
      this.$forceUpdate()
    },
    MQTT() {
      if (this.yhubmqtt) {
        // console.log('yhubmqtt-----', this.yhubmqtt)
        // this.$route.query.mcuId = '05d6ff393430475043165127'
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.$route.query.mcuId) == -1) return
        if (this.yhubmqtt.payload === 'mCan') {
          // console.log('this.yhubmqtt---', this.yhubmqtt.mCan)
          var mCanData = this.yhubmqtt.mCan
          // console.log('payload***', mCanData.payload)
          if (!mCanData) return
          if (mCanData.payload === 'mTCRRealTimeData') {
            this.acChargeMqttData = mCanData.mTCRRealTimeData // 实时详情、警告
            console.log('this.acChargeMqttData---', this.acChargeMqttData)
            if (!this.acChargeMqttData) return
            if (this.acChargeMqttData) {
              this.timeAgo = i18n.t('dataAndTime.AMomentAgo')
              this.timeAgoRST = new Date().getTime()
              if (this.acChargeMqttData.connection === 1) { // 设备状态 1：连接 0：断开
                this.isAllOn = true
              } else {
                this.isAllOn = false
              }
              this.acChargeData.machineModel = this.acChargeMqttData.machineModel.toString(16)
              this.modelType = this.acChargeMqttData.machineModel.toString(16)
              this.acChargeData.plugV = this.acChargeMqttData.AC_V > 100 ? this.acChargeMqttData.AC_V / 100 : this.acChargeMqttData.AC_V
              this.acChargeData.acChargeTem = this.acChargeMqttData.envTemp > 10000 ? -Math.round((this.acChargeMqttData.envTemp - 10000) / 10) : Math.round(this.acChargeMqttData.envTemp / 10)
              if (this.acChargeMqttData.CH1_V > 100) this.acChargeData.cellTeamV1 = this.acChargeMqttData.CH1_V / 100
              if (this.acChargeMqttData.CH2_V > 100) this.acChargeData.cellTeamV2 = this.acChargeMqttData.CH2_V / 100
              if (this.acChargeMqttData.CH3_V > 100) this.acChargeData.cellTeamV3 = this.acChargeMqttData.CH3_V / 100
              if (this.acChargeMqttData.errorCode) this.isShowWarning = true
              var batConnectedArr = []
              if (this.acChargeMqttData.batConnected) {
                batConnectedArr = this.decimalToBinary(this.acChargeMqttData.batConnected)
                // console.log(batConnectedArr)
                if (batConnectedArr[0] == 1) {
                  this.isCellTeamOn1 = true
                  if (this.acChargeMqttData.charge_I) this.acChargeData.cellTeamA1 = this.acChargeMqttData.charge_I / 100
                } else { this.isCellTeamOn1 = false }
                if (batConnectedArr[1] == 1) {
                  this.isCellTeamOn2 = true
                  if (this.acChargeMqttData.charge_I) this.acChargeData.cellTeamA2 = this.acChargeMqttData.charge_I / 100
                } else { this.isCellTeamOn2 = false }
                if (batConnectedArr[2] == 1) {
                  this.isCellTeamOn3 = true
                  if (this.acChargeMqttData.charge_I) this.acChargeData.cellTeamA3 = this.acChargeMqttData.charge_I / 100
                } else { this.isCellTeamOn3 = false }
              }
            }
          }
        }
      }
    },
    setTimer() { // 定时器
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.timeAgoRST) { this.timeAgo = howLongAgo(this.timeAgoRST) }
        }, 600)
      }
    },
    getBit(n, k) {
      var bx = false
      if (((n >> k) & 1) == 1) {
        bx = true
      } else {
        bx = false
      }
      return bx
    },
    decimalToBinary(num) { // 十进制转二进制
      var myNum = num
      var b = []
      while (1) {
        var remainder = num % 2
        b.unshift(remainder)
        num = parseInt(num / 2)
        if (num == 0) break
      }
      var len
      if (myNum < 10) {
        len = 4 - b.length
        for (var i = 0; i < len; i++) {
          b.unshift(0)
        }
      } else if (myNum >= 10 && myNum < 100) {
        len = 8 - b.length
        for (var j = 0; j < len; j++) {
          b.unshift(0)
        }
      }
      return b.reverse()
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0
}
.bag{
  background:#e0e0e085;
}
.card-panel{
  padding-bottom: 20px;
}
#acChargeDetail{
  .content{
    background:white;
    margin-top: 32px;
    padding: 20px;
  }
  .middleContentWarp{
    padding:0 5%;
    // border:1px solid red;
    height: 550px;
    width: 100%;
    background: white;
    padding-top: 20px;
  }
  .middleContentLeft{
    // height: 300px;
    // border:1px solid red;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .middleContentLeft>div{
    // border:1px solid red;
    // width:100px;
    // height:200px;
  }
  .plugWarp>div:nth-of-type(1){
    display: flex;
    justify-content: center;
  }
  .plugWarp>div:nth-of-type(1) img{
    width: 100px;
    margin-bottom: 10px;
  }
  .plugWarp>div:nth-of-type(2){
    text-align: center;
  }
  .plugWarp>div:nth-of-type(2) img{
    width:30px;
  }
  .plugWarp>div:nth-of-type(2) span{
    line-height: 30px;
    vertical-align: top;
  }
  .soildLine{
    width:100px;
    border-top:3px solid #63bb38;
  }
  .greenDeltaRight{//向右三角形
    width: 0;
    height: 0;
    border-left: 15px solid #63bb38;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
  }
  .acChargeDiv{
    position: relative;
  }
  .acChargeDiv div:first-child p{
    text-align: center;
  }
  .acChargeDiv>div{
    display: inline-block;
  }
  .acChargeDiv .acChargeInfo{
    vertical-align: top;
  }
  .acChargeInfo>div{
    margin-top:40px;
  }
  .temInfo{
    display: flex;
    align-items: center;
    position: absolute;
    right: 20px;
    top: -45px;
  }

  .middleContentRight{
    height: 400px;
    // border:1px solid red;
    position: relative;
    padding-left: 20px;
  }
  .middleContentRight>div{
    // border:1px solid red;
    // height:80px;
    position: absolute;
  }
  .arrowOrLine{
    border-top: 3px solid #63bb38;
    border-right: 3px solid #63bb38;
    position: relative;
  }
  .greenDeltaBottom{
    position: absolute;
    bottom: -5px;
    right: -11px;
  }
  .middleContentRight>div:nth-of-type(1){
    width:calc(100% - 100px);
    top: 47px;
    height: 74px;
  }
  .middleContentRight>div:nth-of-type(2){
    width:calc(100% - 280px);
    top: 105px;
    height: 96px;
  }
  .middleContentRight>div:nth-of-type(3){
    width:calc(100% - 460px);
    top: 162px;
    height: 118px;
  }
  .middleContentRight>div:nth-of-type(4){
    right: 0;
    top: 130px;
  }
  .middleContentRight>div:nth-of-type(5){
    right: 180px;
    top: 210px;
  }
  .middleContentRight>div:nth-of-type(6){
    right: 360px;
    top: 290px;
  }
  .greenDeltaBottom{//向下三角形
    width: 0;
    height: 0;
    border-top: 15px solid #63bb38;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
  }
  .cellTeamBoxImg{
    display: flex;
    justify-content: center;
  }
  .cellTeamBox>img{
    width: 160px;
  }
  .cellTeamBoxInfo{
    text-align: center;
  }
  .cellTeamBoxInfo img{
    width:30px;
  }
  .cellTeamBoxInfo span{
    line-height: 30px;
    vertical-align: top;
  }
  .dottedLine{
   border-top: 3px dotted #e3e3e3;
   border-right: 3px dotted #e3e3e3;
  }
  .warningIcon{
    width: 20px!important;
    position:absolute;
    top: -5px;
    left: -10px;
  }
  .warningWarp{
    padding: 0px 5%;
    display: inline-block;
    width:90%;
  }
  .warningWarp img{
    width: 50px;
  }
  .warningWarp .warningImgAndP{
    display: flex;
    align-items: center;
  }
  .warningWarp .warningImgAndP span{
    margin-left: 10px;
    // color: red;
  }
  .warningWarp .warningP{
    margin-top: 10px;
    color: blue;
  }
  .acChargeWarp{
    padding:0 5%;
  }
  // .acChargeDiv{
  //   position: relative;
  // }
  .acChargeImg{
    width:150px;
    // border:1px solid red;
  }
}
</style>

